import { Directive, HostListener, Inject } from "@angular/core";
import { SessionManagerService, SessionManagerServiceToken } from "../service/session-manager.service";
import { Router } from "@angular/router";


/**
 * @whatItDoes This directive listens to user activity events and calls the session manager to update the session state
 * according to the activity.
 *
 * @howToUse You should simply add this directive to a html element, or Angular 2 component. but it is enough to add it
 * to one element in the whole application, but that element should be active on all application screens.
 *
 * ```
 <div class="fund-session-toolbar" session-user-listener>...</div>
 * ```
 *
 * @description
 *
 * A simple user activity monitoring directive.
 *
 * @selector "[session-user-listener]"
 * @ngModule SessionComponentModule
 */
@Directive({
    selector: "[session-user-listener]"
})
export class SessionUserListenerDirective {
    public _sessionManager: SessionManagerService;

    constructor(private router: Router,
                @Inject(SessionManagerServiceToken)
                    sessionManager) {
        this._sessionManager = sessionManager;
    }

    @HostListener("document:keypress", ["$event"])
    onKeypress() {
        this.onUserActivity();
    }

    @HostListener("document:click", ["$event"])
    onClick() {
        this.onUserActivity();
    }

    public onUserActivity(): void {
        if (this.router.url.indexOf("login") < 0) {
          this._sessionManager.onUserEvent();
        }
    }
}
